export const SET_SHIPPY_PENDING_PREFILL = 'SET_SHIPPY_PENDING_PREFILL';
export const CLEAR_SHIPPY_PENDING_PREFILL = 'CLEAR_SHIPPY_PENDING_PREFILL';

export type ShippyPendingPrefill = {
  data: object;
  target: string;
  commandId?: string;
};

export const setShippyPendingPrefill = (prefill: ShippyPendingPrefill) => ({
  type: SET_SHIPPY_PENDING_PREFILL,
  prefill,
});

export const clearShippyPendingPrefill = () => ({
  type: CLEAR_SHIPPY_PENDING_PREFILL,
});
